import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const WebshopRoute: Route = {
  path: '',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/webshop.component').then((m) => m.WebshopComponent),
    },
    {
      path: 'product-list',
      loadComponent: () => import('./pages/product-list.component').then((m) => m.ProductListComponent),
    },
    {
      path: 'product-list/:ingramPartNumber',
      loadComponent: () => import('./pages/product-details.component').then((m) => m.ProductDetailComponent),
    },
    {
      path: 'shopping-cart',
      loadComponent: () => import('./pages/shopping-cart.component').then((m) => m.ShoppingCartComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
